import type { VisitClosureFormData } from "./schemas";

type VisitTimeData = VisitClosureFormData["encounterTimeData"];

const createOptions = <Value extends string>(labels: Record<Value, string>) => {
  return Object.entries(labels).map(([value, label]) => ({
    label,
    value,
  })) as { label: string; value: Value }[];
};

export const PATIENT_TYPE_LABELS = {
  established: "Established",
  new: "New",
} satisfies Record<NonNullable<VisitTimeData["patientType"]>, string>;

export const PATIENT_TYPE_OPTIONS = createOptions(PATIENT_TYPE_LABELS);

export const BILL_TYPE_LABELS = {
  duration: "Visit Duration",
  mdm: "Medical Decision Making",
} satisfies Record<VisitTimeData["billType"], string>;

export const BILL_TYPE_OPTIONS = createOptions(BILL_TYPE_LABELS);

export const VISIT_TYPE_LABELS = {
  av: "A/V",
} satisfies Record<VisitTimeData["visitType"], string>;

export const VISIT_TYPE_OPTIONS = createOptions(VISIT_TYPE_LABELS);
